// Transport failures the browser reports when it could not reach the server, plus webpack's lazy-chunk failures — which online are usually a stale-deploy 404 (a received response), not a transport failure.
const NETWORK_ERROR_MESSAGE_PATTERNS = [
  "Failed to fetch", // Chromium fetch
  "NetworkError when attempting to fetch resource", // Firefox fetch
  "Load failed", // Safari fetch
  "Network Error", // axios
  "Loading chunk", // webpack lazy chunk
];

// True for errors we treat as connectivity noise: transport failures (connection down, DNS failure, aborted socket) plus failed lazy-chunk loads. Membership is wider than "the server never responded" — see ChunkLoadError above — so callers must pair this with a navigator.onLine check (as logError does) before suppressing the error.
export const isNetworkError = (error: unknown): boolean => {
  if (typeof error !== "object" || error === null) {
    return false;
  }
  if ("code" in error && error.code === "ERR_NETWORK") {
    return true;
  }
  if ("name" in error && error.name === "ChunkLoadError") {
    return true;
  }

  const message =
    "message" in error && typeof error.message === "string" ?
      error.message
    : null;
  if (message === null) {
    return false;
  }
  // Case-insensitive: Chromium reports a response body that fails mid-stream as a lowercase "network error", which the axios-cased pattern would otherwise miss.
  const lowerCaseMessage = message.toLowerCase();
  return NETWORK_ERROR_MESSAGE_PATTERNS.some((pattern) =>
    lowerCaseMessage.includes(pattern.toLowerCase())
  );
};
